exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".widget-head[data-v-5c38ef4a]{border:1px solid #3540512b;background:#d7e3e5;color:#000;padding:0 20px}.panel-body[data-v-5c38ef4a]{background-color:#fff;border:1px solid #3540511f}.icon-poster[data-v-5c38ef4a]{height:10px;margin:5px}.div-btns[data-v-5c38ef4a]{padding:15px 0}.btns-poster[data-v-5c38ef4a]{font-family:Gotham;font-size:10px}.btn-clear[data-v-5c38ef4a]{background:#354051}.btn-save[data-v-5c38ef4a]{float:right;background:#ed1763}.btn[data-v-5c38ef4a],.btn[data-v-5c38ef4a]:focus,.btn[data-v-5c38ef4a]:hover{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c38ef4a","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/assets/js/components/Filler.vue
// module id = T33F
// module chunks = 101